import { runAnalytics } from './client';
import type { AnalyticsEvent, AnalyticsProperties } from './events';

export type { AnalyticsEvent, AnalyticsProperties } from './events';

export type TrackInput = {
	event: AnalyticsEvent;
	properties?: AnalyticsProperties;
};

export const track = ({ event, properties }: TrackInput): void =>
	runAnalytics((client) => {
		client.capture(event, properties);
	});
